exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-content[data-v-e3101dec]{line-height:1.6;color:#333}.news-content h1[data-v-e3101dec],.news-content h2[data-v-e3101dec],.news-content h3[data-v-e3101dec],.news-content h4[data-v-e3101dec],.news-content h5[data-v-e3101dec],.news-content h6[data-v-e3101dec]{margin-top:1rem;margin-bottom:.5rem}.news-content p[data-v-e3101dec]{margin-bottom:1rem}.news-content ol[data-v-e3101dec],.news-content ul[data-v-e3101dec]{margin-bottom:1rem;padding-left:1.5rem}", ""]);

// exports
